<template>
  <div class="w-full px-2 py-6 max-h-96 overflow-y-scroll pr-2">
    <div class="relative border-l-[3px] border-green-600 pl-6">
      <div
        v-for="(log, index) in itemActivityLog"
        :key="index"
        class="relative pb-6"
      >
        <!-- Green Dot -->
        <div
          class="absolute left-[-32px] top-0 w-3 h-3 bg-green-600 rounded-full z-10"
        ></div>

        <!-- Content -->
        <div class="space-y-1">
          <div class="text-gray-900 font-medium text-base">
            {{ log.status }}
          </div>

          <span class="inline-block text-xs py-1 font-medium">
            {{ log.description }}
          </span>

          <div class="text-xs text-gray-500">
            {{ log.admin.name }} | {{ dateFormat(log.createdAt) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, inject, onMounted } from "vue";

export default {
  props: {
    itemDataDetails: Object,
  },
  setup(props) {
    const axios = inject("$axios");
    const moment = inject("$moment");
    const itemActivityLog = ref([]);

    const fetchActivityLog = async () => {
      try {
        const transactionNumber = props.itemDataDetails.transactionnumber;
        const { data } = await axios.get(
          `/portal/maintenance/activitylog/${transactionNumber}`
        );
        itemActivityLog.value = data;
      } catch (err) {
        console.error(err);
      }
    };
    const dateFormat = (val) => {
      return moment(val).format("LLL");
    };

    onMounted(() => {
      fetchActivityLog();
    });

    return {
      itemActivityLog,
      dateFormat,
    };
  },
};
</script>
<style scoped>
/* Blue always-visible scrollbar */
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track {
  background: #e0f2fe; /* light blue background (Tailwind blue-100) */
}
::-webkit-scrollbar-thumb {
  border-radius: 4px;
}
</style>
